// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// noinspection ExceptionCaughtLocallyJS

import Vue from 'vue';
import Vuex from 'vuex';
import VueI18n from 'vue-i18n';
import WebFont from 'webfontloader';
import Vue2TouchEvents from 'vue2-touch-events'
import Axios from 'axios';
import VuejsDialog from 'vuejs-dialog';
import VueAutosize from 'vue-autosize';
import VueGtag from 'vue-gtag';

import App from './App';
import router from './router';
import store from './store';
import messages from './translations';
import moment from 'moment';

export function sanitize(text) {
    if (text && typeof text === 'string') {
        return text
            .replaceAll(/\\/g, '\\\\')
            .replaceAll(/"/g, '\\"')
            .replaceAll(/%/g, '\\%')
    } else {
        return text
    }
}

Vue.config.productionTip = false;

Vue.use(Vuex);
Vue.use(VueI18n);
Vue.use(Vue2TouchEvents, {})
Vue.use(VuejsDialog);
Vue.use(VueAutosize);

if (window.location.hostname === 'app.horesplus.com' || window.location.hostname.endsWith('hores.app')) {
    Vue.use(VueGtag, {
        config: {
            id: 'G-R5BRTMRJL5',
            params: {
                pageTrackerSkipSamePath: false,
                pageTrackerUseFullPath: true
            }
        }
    });
}

// vue translations settings
let locale = localStorage.getItem('locale') || 'cs';
moment.locale(locale)

const i18n = new VueI18n({
    locale: locale,
    messages: messages
});

// webfont loader
WebFont.load({
    custom: {
        families: ['Roboto', 'iconfont'],
        urls: ['static/fonts/style.css', 'static/icons/style.css'],
        testStrings: {
            'icofont': '\ue905'
        }
    }
});

export function computePriceMaskText(priceMaskMap, currency) {
    if (!currency) {
        return ''
    } else {
        let totalPrice = undefined;

        priceMaskMap.forEach(function (price) {
            const numPrice = price !== '' ? Number(price) : undefined;
            if (Number.isFinite(numPrice)) {
                if (totalPrice === undefined) {
                    totalPrice = 0;
                }

                // Price není float ale vždy text, aby to bylo přesné, tady je Number jen, abych to mohl jednoduše sečíst
                totalPrice += numPrice;
            }
        });

        return totalPrice !== undefined ? totalPrice.toFixed(2) + ' ' + currency : undefined
    }
}

export function priceMaskArrayToMap(priceMaskArray) {
    return new Map(priceMaskArray.map(i => [moment(i.date).format('YYYY-MM-DD'), i.price]))
}

// FIXME dořešit možné znaky v kódu hotelu
const domainRegexp = (base = 'hores.app') => new RegExp(`^([a-zA-Z0-9_\\-]+)\.${base}\$`)

const hostname = window.location.hostname;
let endpoint = '/service/exec';
let domainMatch;
let openHotelDomain;
if (hostname === 'app.horesplus.com' || hostname === 'hores.app' || (domainMatch = hostname.match(domainRegexp()))) {
    //endpoint = 'https://hores.app/service/exec'
    openHotelDomain = 'https://$.hores.app'
} else if (hostname === 'apptest.horesplus.com' || (domainMatch = hostname.match(domainRegexp('apptest.horesplus.com')))) {
    //endpoint = 'https://apptest.horesplus.com/service/exec'
    openHotelDomain = 'https://$.apptest.horesplus.com'
} else if (hostname === 'hores.localhost' || hostname === '192.168.100.173' || (domainMatch = hostname.match(domainRegexp('hores.localhost')))) {
    //endpoint = '/service/exec'
    openHotelDomain = 'https://$.hores.localhost'
} else {
    throw new Error('Unknown hostname: ' + hostname)
}

export function openHotel(hotelCode) {
    const hash = window.location.hash ? window.location.hash.replace(/^#/, '') : ''
    window.open(`${openHotelDomain.replace('$', hotelCode)}?page=${hash}`, '_self')
}

export function isInDomainMode() {
    return !!domainMatch
}

if (domainMatch) {
    localStorage.setItem('hotelCode', domainMatch[1]);
} else {
    let pathCode = window.location.pathname.replace(/^\/|\/$/g, '');

    if (pathCode) {
        localStorage.setItem('hotelCode', pathCode);
        openHotel(pathCode)
    }
}

Axios.defaults.baseURL = endpoint;
Axios.defaults.method = 'POST';
Axios.defaults.withCredentials = true;
Axios.defaults.timeout = 30000;
Axios.defaults.headers.common = {
    'X-hotelCode': localStorage.getItem('hotelCode'),
};

let logoutDialogShown = false

function unauthorized(messageKey) {

    if (!logoutDialogShown) {
        logoutDialogShown = true
        Vue.dialog.alert(i18n.t(messageKey), {okText: 'Ok'})
            .then(() => {
                logoutDialogShown = false
            })
            .catch(() => {
                logoutDialogShown = false
            });
    }

    router.push({path: '/logout'});
}

Axios.interceptors.response.use(response => {
    // Jediný, kdo tohle může vrátit je bridge
    if (response.status === 401 || response.status === 403) {
        unauthorized('login_expired')
        throw {
            code: response.status,
            message: i18n.t('no_permission')
        }
    }

    if (response.data && response.data.errors) {
        if (response.data.errors.status === '401 Unauthorized') {
            unauthorized('login_expired')
            throw {
                code: 401,
                message: i18n.t('login_expired')
            }
        }

        if (response.data.errors.status === '401 Hotel not found') {
            unauthorized('hotel_not_found')
            throw {
                code: 401,
                message: i18n.t('hotel_not_found')
            }
        }
    }

    if (response.data === '403 Forbidden') {
        throw {
            code: 403,
            message: i18n.t('no_permission')
        }
    }

    if (Array.isArray(response.data.errors) && response.data.errors.length > 0) {
        const err = response.data.errors[0]
        const ext = err.extensions
        if (ext) {
            throw {
                code: ext.code ? ext.code : -1,
                message: ext.display_message
            }
        } else if (err.message) {
            // Následně zobrazeno jako neznámá chyba s dodatkem
            throw {
                message: err.message
            }
        } else {
            // Následně zobrazeno jako neznámá chyba
            throw {}
        }
    }

    return response;
});

Vue.component('layout-header', () => import('@/templates/layout/header'));
Vue.component('layout-nav', () => import('@/templates/layout/nav'));
Vue.component('part-pagination', () => import('@/templates/part/ui/pagination'));
Vue.component('part-reservation', () => import('@/templates/part/item/reservation'));
//Vue.component('part-guest', () => import('@/templates/part/item/guest'));
Vue.component('part-guest-group', () => import('@/templates/part/item/guest-group'));

Vue.component('part-guest-item', () => import('@/templates/part/item/guest-item'));
Vue.component('part-booking', () => import('@/templates/part/item/booking'));
Vue.component('part-graph-bar', () => import('@/templates/part/item/graph_bar'));
Vue.component('part-checkin-edit', () => import('@/templates/part/checkin_edit'));
Vue.component('part-checkin-guest', () => import('@/templates/part/checkin_guest'));
Vue.component('part-chart-line', () => import('@/templates/part/chart/line'));
Vue.component('part-chart-wrapper', () => import('@/templates/part/chart/wrapper'));
Vue.component('part-calendar-detail', () => import('@/templates/part/item/calendar_detail'));
Vue.component('settings-price-mask', () => import('@/templates/comp/settings-price-mask'));
Vue.component('room-label', () => import('@/templates/part/item/room-label'));
Vue.component('date-input', () => import('@/templates/part/item/date_input'));
Vue.component('edit-item', () => import('@/templates/part/ui/edit-item'));
Vue.component('custom-select', () => import('@/templates/part/ui/custom-select'));
Vue.component('custom-search-select', () => import('@/templates/part/ui/custom-search-select'));
Vue.component('guest-profile-detail', () => import('@/templates/part/ui/guest-profile-detail'));
Vue.component('room-account-detail', () => import('@/templates/part/ui/room-account-detail'));

/* eslint-disable no-new */

export function fetchZenDesk(articleId) {
    const locale = localStorage.getItem('locale');
    const zenDeskLocale = locale && locale.startsWith('cs') ? 'cs' : 'en-gb'
    return fetch(`https://hores.zendesk.com/api/v2/help_center/${zenDeskLocale}/articles/${articleId}`)
        .then(res => {
            if (res.status === 200) {
                return res.json();
            }
            if (res.status === 404) {
                return 'not-found'
            } else {
                throw Error();
            }
        })
        .then(json => {
            if (json === 'not-found') {
                return 'not-found'
            } else {
                return json.article;
            }
        })
}

let runApp = function () {

    Vue.mixin({
        data() {
            return {
                hideHead: false
            }
        },
        methods: {
            handleGlobalScroll: function (event) {
                /*if (event.target.scrollTop > 1 && window.innerWidth < 960) {
                    this.$parent.$el.querySelector('#layout_header').classList.add('mod--not-top');
                } else {
                    this.$parent.$el.querySelector('#layout_header').classList.remove('mod--not-top');
                }*/
            },

            showError: function (error) {
                console.error(error)

                console.error(new Error().stack);

                if (error.code === 401 && !error.forceShowError) {
                    // Ignorování, pokud je chyba 401 (a není forceShowError z loginu) - ta už je vyřešená, včetně redirectu, o úroveň výše v interceptoru
                    return;
                }

                let msg;
                if (error.message) {
                    if (error.code) {
                        // Značí chybu obdrženou z API
                        msg = error.message
                    } else {
                        // Chyba JS
                        msg = 'Error: ' + error.message
                    }
                } else {
                    msg = i18n.t('unknown_error')
                }

                Vue.dialog.alert(msg, {okText: 'Ok'});
            },
        }
    });

    new Vue({
        el: '#app',
        router,
        store,
        i18n,
        components: {App},
        template: '<App/>'
    });
};

runApp();



// WEBPACK FOOTER //
// ./src/main.js